module.exports = __webpack_public_path__ + "static/media/web-banner.a62ab2fe.jpg";